import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { constants, compose } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'

import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import SearchInput from 'layouts/InsideLayout/Header/HeaderSearchInput/HeaderSearchInput'
import AlgoliaSearchInput from 'layouts/InsideLayout/Header/HeaderAlgoliaSearchInput/HeaderAlgoliaSearchInput'
import Logo from 'components/ui/Logo/Logo'

import GetFreeButton from './GetFreeButton/GetFreeButton'

import s from './HeaderContent.scss'


const HeaderContent = ({ logoLink, isAlgoliaSearchEnabled }) => (
  <div className={s.headerContent}>
    <WidthContainer>
      <div className={s.content}>
        <div className={s.side}>
          {isAlgoliaSearchEnabled ? <AlgoliaSearchInput /> : <SearchInput />}
        </div>
        <Logo className={s.logo} dark to={logoLink} />
        <div className={cx(s.side, s.right)}>
          <GetFreeButton />
        </div>
      </div>
    </WidthContainer>
  </div>
)

HeaderContent.propTypes = {
  logoLink: PropTypes.string,
  isAlgoliaSearchEnabled: PropTypes.bool, // @injectGlobals
}


export default compose(
  injectGlobals(({ getAbValue, getFeatureToggle }) => ({
    isAlgoliaSearchEnabled:
      getFeatureToggle(constants.features.algoliaSearch)
      && getAbValue(constants.abTests.algoliaSearch) === 'b',
  })),
)(HeaderContent)
